import * as React from 'react';
import { connect } from 'react-redux';
import LoginTab from '@src/containers/login-overlay/login-tab/LoginTab';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import './TabManager.scss';
import { ILoginState, ILoginView } from '@src/reducers/LoginReducer';
import { RootState } from '@src/reducers';
import RegisterTab from '@src/containers/login-overlay/register-tab/RegisterTab';
import ForgotPassword from '@src/containers/login-overlay/login-tab/forgot-password/ForgotPassword';

interface IReduxState {
    view: ILoginView;
}

interface IReduxActions {}

type IAllProps = IReduxState & IReduxActions;

class TabManager extends React.Component<IAllProps, {}> {
    render() {
        const { view } = this.props;
        let component: any;
        switch (view) {
            case ILoginView.forgotPassword:
                component = <ForgotPassword />;
                break;

            case ILoginView.register:
                component = <RegisterTab />;
                break;

            default:
                component = <LoginTab />;

        }

        return (
            <div className="TabManager-wrap">
                <TransitionGroup
                    className={`animation-wrap ${ view === ILoginView.login &&
                        'animate-back'}`}>
                    {
                        <CSSTransition
                            key={view}
                            timeout={500}
                            classNames="fade">
                            {component}
                        </CSSTransition>
                    }
                </TransitionGroup>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    const loginState: ILoginState = state.loginState;
    return {
        view: loginState.view,
    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {};
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(TabManager);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/tab-manager/TabManager.tsx